import { Box, Button, Flex, SimpleGrid, Table, Tbody, Td, Text, Tr } from "@chakra-ui/react";
import { FaRegCheckSquare, FaRegSquare } from "react-icons/fa";
import { FormattedMessage, useIntl } from "react-intl";

import { Scenario } from "@nens/ldo/api-v1";
import { useClipboard } from "@nens/react/hooks";

interface MetadataTableProps {
  scenario: Scenario;
}

export function MetadataTable({ scenario }: MetadataTableProps) {
  const intl = useIntl();
  const locale: "nl" | "en" = intl.locale === "en" ? "en" : "nl";
  const copy = useClipboard()[1];
  return (
    <SimpleGrid columns={1} spacing={10} w="full" my="40px">
      <Box rounded="md" border="1px solid #ccc">
        <Flex
          borderBottom="1px solid #ccc"
          py="10px"
          px="14px"
          justifyItems={"flex-start"}
          alignItems={"center"}
          gap={4}
        >
          <Text fontWeight={"semibold"}>Metadata</Text>
          <Box
            color="bij12_1.700"
            fontWeight="semibold"
            bgColor={"#CC614D20"}
            fontSize={"sm"}
            rounded="full"
            px="14px"
            py="1px"
          >
            {scenario.numFilledInMetadataProperties}
          </Box>
          <Text fontSize="80%">
            <FormattedMessage
              id="scenario.metadata.version"
              defaultMessage="Validated against metadata definition version: {version}"
              values={{ version: scenario.metadataId }}
            />
          </Text>
        </Flex>
        {scenario.metadataHeaders.map((header) => (
          <Box key={header} p="4">
            <Text fontWeight="semibold" pb="8px">
              {header} ({scenario.getPropertiesByHeader(header).filter((p) => p.filledIn).length})
            </Text>

            <Table size="sm" variant="striped" colorScheme="gray" border="1px solid #ddd">
              <Tbody>
                {scenario.getPropertiesByHeader(header).map((property) =>
                  property.filledIn ? (
                    <Tr key={property.key}>
                      <Td width="20%" valign="top" title={property.text[locale].description}>
                        {property.text[locale].title}
                      </Td>
                      <Td width="80%" fontWeight="normal" title={property.type}>
                        <Flex justifyContent="space-between">
                          <Flex>
                            {typeof property.value === "boolean" && property.value === true ? (
                              <FaRegCheckSquare />
                            ) : typeof property.value === "boolean" && property.value === false ? (
                              <FaRegSquare />
                            ) : (
                              property.value
                            )}
                          </Flex>
                          <Button
                            onClick={() => {
                              const value = property.value?.toString();
                              if (value) {
                                copy(value);
                              }
                            }}
                            variant="ghost"
                            size="xs"
                          >
                            copy
                          </Button>
                        </Flex>
                      </Td>
                    </Tr>
                  ) : (
                    <Tr key={property.text[locale].title}>
                      <Td width="20%" title={property.text[locale].description}>
                        {property.text[locale].title}
                      </Td>
                      <Td width="80%" fontWeight="normal">
                        -
                      </Td>
                    </Tr>
                  )
                )}
              </Tbody>
            </Table>
          </Box>
        ))}
      </Box>
    </SimpleGrid>
  );
}
